// layers/pdars.ts
import type { LayerSpecification } from "maplibre-gl";
import { SOURCES } from "../sources";
import { LAYERS } from "./constants";

export const pdars: LayerSpecification = {
  id: LAYERS.PDARS || "pdars-layer",
  type: "symbol",
  source: SOURCES.PDAR,

  filter: [
    "in",
    ["coalesce", ["get", "entity_type"], ""],
    ["literal", ["platform", "target", "sensor"]],
  ],

  layout: {
    "icon-image": ["coalesce", ["get", "markerImage"], "pdar-sensor"],
    // Sensors rotate to their resolved orientation (wire orientation + the
    // client-side calibration offset set via the orientation slider — see
    // PdarsManager.flushUpdates); platform/target features rotate to their
    // heading as before.
    "icon-rotate": [
      "case",
      ["==", ["get", "entity_type"], "sensor"],
      ["coalesce", ["get", "orientation_deg"], 0],
      ["coalesce", ["get", "heading_deg"], 0],
    ],
    "icon-rotation-alignment": "map",
    "icon-allow-overlap": true,
    "icon-ignore-placement": true,
    "symbol-sort-key": ["*", ["coalesce", ["get", "altitude_ft"], 0], -1],
    "icon-size": [
      "case",
      ["boolean", ["get", "isSelected"], false],
      0.45,
      0.35,
    ],
    "text-field": [
      "step",
      ["zoom"],
      "",
      8,
      [
        "match",
        ["coalesce", ["get", "entity_type"], ""],
        "target",
        [
          "format",
          ["coalesce", ["to-string", ["get", "pdar_id"]], "UNKNOWN"],
          { "font-scale": 0.8 },
          "\nALT: ",
          { "font-scale": 0.6, "text-color": "#888888" },
          ["to-string", ["coalesce", ["get", "altitude_ft"], 0]],
          { "font-scale": 0.8 },
          " ft\nSPD: ",
          { "font-scale": 0.6, "text-color": "#888888" },
          ["to-string", ["coalesce", ["get", "speed_knots"], 0]],
          { "font-scale": 0.8 },
          " kt",
        ],
        "",
      ],
    ],
    "text-font": ["IBM Plex Mono Regular"],
    "text-rotation-alignment": "map",
    "text-allow-overlap": true,
    "text-ignore-placement": true,
    // 🛡️ Safe hard fallbacks prevent WebGL anchor compilation crashes
    "text-anchor": [
      "case",
      [">", ["coalesce", ["get", "heading_deg"], 0], 180],
      "left",
      "right",
    ],
    "text-justify": [
      "case",
      [">", ["coalesce", ["get", "heading_deg"], 0], 180],
      "left",
      "right",
    ],
    "text-radial-offset": 1.8,
  },
  paint: {
    "icon-color": [
      "match",
      ["coalesce", ["get", "entity_type"], ""],
      "platform",
      "#C6E2FA",
      "sensor",
      "#D7EBC4",
      "target",
      "#E09895",
      "#FFFFFF",
    ],
    "icon-halo-width": 0.4,
    "text-color": [
      "case",
      ["boolean", ["get", "isSelected"], false],
      "#FFFFFF",
      "#BBBBBB",
    ],
    "text-halo-color": "#101010",
    "text-halo-width": 6,
    "text-halo-blur": 1.5,
  },
};
